/**
 * Tiny 16px logo badge for the Clients sub-nav (Header) and any other place
 * where we want a favicon-style thumbnail of a client reference.
 *
 * Rules:
 *   • public references with a `logo_url` → render the logo image on a white pill
 *   • anonymous / logo-less references     → render the first letter of the name
 *     on a dark pill so the sub-nav stays readable on the #0f172a strip
 *   • image errors gracefully fall back to the letter avatar
 */
import { useState } from "react";

const ClientLogoBadge = ({ client, size = 16, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const name = client?.client_name || client?.anonymous_descriptor || "";
  const initial = (name.trim()[0] || "?").toUpperCase();
  const isAnonymous = client?.confidentiality === "anonymous";
  const canShowLogo = !isAnonymous && client?.logo_url && !failed;
  const s = `${size}px`;

  if (canShowLogo) {
    return (
      <span
        aria-hidden="true"
        className={`inline-flex items-center justify-center bg-white rounded-sm overflow-hidden shrink-0 ${className}`}
        style={{ width: s, height: s }}
      >
        <img
          src={client.logo_url}
          alt=""
          onError={() => setFailed(true)}
          className="max-w-full max-h-full object-contain"
        />
      </span>
    );
  }

  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-sm bg-[#1F2937] text-[#00A878] font-mono-dl font-bold shrink-0 ${className}`}
      style={{ width: s, height: s, fontSize: `${Math.round(size * 0.6)}px` }}
    >
      {initial}
    </span>
  );
};

export default ClientLogoBadge;
